module.exports = __webpack_public_path__ + "static/icon-a91b855672761e9d11818fbff57758be.png";